import { render } from "./VideoView.vue?vue&type=template&id=3bb12406&scoped=true"
import script from "./VideoView.vue?vue&type=script&lang=js"
export * from "./VideoView.vue?vue&type=script&lang=js"

import "./VideoView.vue?vue&type=style&index=0&id=3bb12406&lang=scss&scoped=true"

import exportComponent from "/home/ak/projects/ysm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb12406"]])

export default __exports__